// #region imports

// --- Angular
import { Component, EventEmitter, Input, Output } from '@angular/core';

// --- HS Code
import { cookiePolicyAnimation } from './cookie-policy.animations';

// #endregion

@Component({
  selector: 'hs-cookie-policy',
  templateUrl: './cookie-policy.component.html',
  styleUrls: ['./cookie-policy.component.scss'],
  animations: [cookiePolicyAnimation]
})
export class CookiePolicyComponent {

  @Input() cookiePolicyMessage: string = '';
  @Input() accepted: boolean | null = false;
  @Output() accept = new EventEmitter();

  onAccept() {
    this.accept.emit();
  }
}
